export class Country {
  public iso_3166:          string;
  public iso_639:           string;
  public ny_iso:            string;
  public name:              string;
  public localized_name:    string;
  public currency:          string;
  public region:            string;
  public app:               boolean;
  public loyalty:           boolean;
  public showOriginalPrice: boolean;
  public latitude:          string;
  public longitude:         string;
  public restricted:        boolean;
  public disabled:          boolean;

  constructor (data:any) {
    this.iso_3166           = data.iso_3166;
    this.iso_639            = data.iso_639;
    this.ny_iso             = data.ny_iso;
    this.name               = data.name;
    this.localized_name     = data.localized_name;
    this.currency           = data.currency;
    this.region             = data.region;
    this.app                = data.app;
    this.loyalty            = data.loyalty;
    this.showOriginalPrice  = data.showOriginalPrice;
    this.latitude           = data.lat;
    this.longitude          = data.lng;
    this.restricted         = data.restricted;
    this.disabled           = data.disabled;
  }
}
